import React from "react";
import { List } from "semantic-ui-react";
import { WidgetProps } from "@rjsf/core";
import FileView from '../../../../sg-fileupload/components/File'

interface IFileUpload6 extends WidgetProps {
  type?: string
}

const FileUpload6Display = (props: IFileUpload6) => {

  const {
    id,
    value,
    placeholder,
    formContext,
  } = props

  if (value && value.length) {
    return (
      <List id={id} className="FileUpload6Display ImageList">
        {(value || []).map((file: any) => (
          <List.Item key={file.id}>
            <FileView
              title={file.name}
              className="ImageList_img"
              id={file.id}
            />
          </List.Item>
        ))}
      </List>
    )
  };

  return <div>{placeholder || formContext.emptyValue}</div>

};

export default FileUpload6Display;

